import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngCookies from 'angular-cookies';
import moment from 'angular-moment';
import routing from './demand_detail.routes';
import InstActivePowerService from '../../../components/api/inst_active_power/inst_active_power.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import MonthlyMaxDemandPowerService from '../../../components/api/monthly_max_demand_power/monthly_max_demand_power.service';
import EventService from '../../../components/api/event/event.service';
import DeviceErrorService from '../../../components/api/device_error/device_error.service';
import PredictedPowerService from '../../../components/api/predicted_power/predicted_power.service';
import ActivePowerService from '../../../components/api/active_power/active_power.service';
import WeatherService from '../../../components/api/weather/weather.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import MathUtil from '../../../components/logic/math_util/math_util';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import chartConfig from './demand_detail.config';

export class DemandDetailController {
  /*@ngInject*/
  constructor($state, $stateParams, $q, $interval, $rootScope, $cookies, moment, InstActivePowerService, SaConfigService, MonthlyMaxDemandPowerService, DateUtil, MathUtil, CsvUtil, EventService, DeviceErrorService, PredictedPowerService, ActivePowerService, WeatherService) {
    const self = this;
    this.id = $stateParams.id;
    this.cookies = $cookies;
    this.q = $q;
    this.state = $state;
    this.interval = $interval;
    this.rootScope = $rootScope;
    this.moment = moment;
    this.InstActivePowerService = InstActivePowerService;
    this.SaConfigService = SaConfigService;
    this.MonthlyMaxDemandPowerService = MonthlyMaxDemandPowerService;
    this.EventService = EventService;
    this.DeviceErrorService = DeviceErrorService;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.PredictedPowerService = PredictedPowerService;
    this.ActivePowerService = ActivePowerService;
    this.WeatherService = WeatherService;
    this.MathUtil = MathUtil;
    this.predictedDemand = null;
    this.predictedPercentage = null;
    this.chartConfig = chartConfig(this);
    this.deviceError = {};
    this.currentWeather = {};
    this.remainingTimeStr = '00:00';
    this.downloadFileName = 'event.csv';
  }

  $onInit() {
    this.SaConfigService.api.show({id: this.id}).$promise
      .then(response => {
        this.saConfig = response;
        this.targetPower = this.saConfig.target_power;
        this.limitPower = this.saConfig.limit_power;
        this.contractPower = this.saConfig.contract_power;

        if (this.chart || this.rootScope.isSimpleDisplay || this.rootScope.isTabletDisplay) {
          this.update();
        }

        if (!this.rootScope.isTabletDisplay) {
          this.timer = this.interval(() => {
            this.update();
          }, 20000);
        } else {
          // 通信量削減のため、タブレット表示時のみ60秒間隔で画面更新
          this.timer = this.interval(() => {
            this.update();
          }, 60000);
        }

        this.remaningTimer = this.interval(() => {
          this.updateTime();
        }, 1000)
      })
      .catch(err => {
        if (err.status === 404 || err.status === 403) {
          this.state.go('main.home');
        }
      });

    this.MonthlyMaxDemandPowerService.show(
      {id: this.id},
      max_power => { this.maxPower = max_power; },
      error_response => { this.maxPower = null; }
    );
  }

  update() {
    // Cookieの値を使ってフラグを制御
    if (this.cookies.get('tabret_view') === 'on' ) {
    	this.rootScope.isFullScreen = true;
    	this.rootScope.isTabletDisplay = true;
    }

    let instActivePowers = null;
    let predictedValue = null;
    let basePower = null;
    this.targetDate = new Date();
    [this.demand_start_time, this.demand_end_time] = this.DateUtil.getDemandRange(this.moment(this.targetDate).add(this.moment().utcOffset(), 'minutes').toDate());

    this.q.all([
      this.InstActivePowerService.api.show({id: this.id}).$promise,
      this.ActivePowerService.show(this.activePowerQuery(this.id, this.demand_start_time)).$promise
    ]).then(responses => {
      instActivePowers = responses[0];

      let activePowers = responses[1].powers;
      if (activePowers.length > 0) {
        basePower = activePowers[0].value;
      }

      return this.PredictedPowerService.api.show({id: this.id}).$promise;
    })
      .then(response => {
        predictedValue = response.value;
      })
      .finally(() => {
        this.updateGraph(instActivePowers, predictedValue, basePower);
      });

    //同時にイベントリスト、エラー情報、今月の最大デマンド、天候情報を更新
    // 通信量削減のためTabletDisplay時は、エラー情報しか更新しない
    this.DeviceErrorService.api.show({id: this.id}, response => {
      this.deviceError = response;
    });
    if (!this.rootScope.isTabletDisplay) {
      this.EventService.api.show({id: this.id}, response => {
        this.eventList = response;
        this.eventCsv = this.CsvUtil.processEvent(this.eventList);
        this.downloadFileName = this.moment().format('[event]_YYYY-MM-DD[.csv]');
      });
      this.MonthlyMaxDemandPowerService.show(
       {id: this.id},
       max_power => { this.maxPower = max_power; },
       error_response => { this.maxPower = null; }
      );
      this.WeatherService.api.index({sa_config_id: this.id}, res => {
        this.currentWeather = res[0];
      });
    }
  }

  updateGraph(instActivePowers, predictedValue, basePower) {
    //kWh => kW へ変換(2倍する)
    let todayPowers = instActivePowers.today_powers.map(power => {
      return {
        value: power.value * 2,
        measured_at: power.measured_at
      };
    });
    let yesterdayPowers = instActivePowers.yesterday_powers.map(power => {
      return {
        value: power.value * 2,
        measured_at: power.measured_at
      };
    });

    let lastPower = todayPowers[todayPowers.length - 1];
    let beforePower = todayPowers[todayPowers.length - 2];

    this.currentPower = null;
    this.powerDiff = null;
    let base = null;
    if (todayPowers.length > 0) {
      base = (basePower === null || basePower === 0) ? todayPowers[0].value : basePower * 2;
      this.currentPower = this.MathUtil.subtract(lastPower.value, base);
      this.powerDiff = this.MathUtil.subtract(lastPower.value, beforePower.value);
    }

    let contract_powers = [];
    let limit_powers = [];
    let target_powers = [];

    if (this.contractPower !== 0) {
      this.predictedDemand = predictedValue;

      let insertTime = this.moment(this.demand_start_time);
      for (let i = 0; i <= 15; i++) {
        contract_powers.push([insertTime.valueOf(), this.contractPower]);
        limit_powers.push([insertTime.valueOf(), this.limitPower]);
        target_powers.push([insertTime.valueOf(), this.targetPower]);
        insertTime.add(2, 'minutes');
      }
    }

    let predictedData = [];
    let baseThreshold = this.effectiveThreshold(this.targetPower, this.limitPower, this.contractPower);
    if (this.predictedDemand !== null) {
      predictedData.push([this.moment(lastPower.measured_at).add(9, 'hours').valueOf(), this.currentPower]);
      predictedData.push([this.demand_end_time.valueOf(), this.predictedDemand]);

      this.predictedPercentage = 100 * this.predictedDemand / baseThreshold;
    }

    if (this.rootScope.isSimpleDisplay || this.rootScope.isTabletDisplay) {
      return;
    }

    this.chart.setTitle({text: 'デマンド状況と予測'}, {text: this.DateUtil.getDemandTitle(this.targetDate)}, false);
    this.chart.series[0].setData(target_powers, false);
    this.chart.series[1].setData(limit_powers, false);
    this.chart.series[2].setData(contract_powers, false);
    this.chart.series[3].setData(predictedData, false);
    this.chart.series[4].setData(this.formatInstActivePowers(yesterdayPowers, null, 1), false);
    this.chart.series[5].setData(this.formatInstActivePowers(todayPowers, base, 0), false);

    this.chart.redraw();
    this.chart.reflow();
  }

  updateTime() {
    let now = this.moment();
    let end = this.moment(this.demand_end_time).subtract(9, 'hours');
    let minutesDiff = end.diff(now, 'minutes');
    let secondsDiff = end.diff(now, 'seconds') % 60;

    this.remainingTimeStr = `${this.zeroPadding(minutesDiff)}:${this.zeroPadding(secondsDiff)}`;
    this.remainingDiff = end.diff(now, 'seconds');
  }

  zeroPadding(num) {
    if (num < 0) {
      num = 0;
    }
    return `0${num}`.slice(-2);
  }

  $onDestroy() {
    this.rootScope.isFullScreen = false;
    this.rootScope.isSimpleDisplay = false;
    this.rootScope.isTabletDisplay = false;

    if (this.timer) {
      this.interval.cancel(this.timer);
    }
    if (this.remaningTimer) {
      this.interval.cancel(this.remaningTimer);
    }
    // 有効期限は設けず、Session切れでcookieが消えるようにする
    this.cookies.put('tabret_view', 'off');
  }

  formatInstActivePowers(instActivePowers, base, elapsedDate) {
    if (instActivePowers.length === 0) {
      return [];
    }
    base = base || instActivePowers[0].value;

    return instActivePowers.map((instActivePower) => {
      return {
        x: this.DateUtil.leapJstDate(instActivePower.measured_at, elapsedDate),
        y: this.MathUtil.subtract(instActivePower.value, base)
      };
    });
  }

  activePowerQuery(id, demandStartTime) {
    let target = this.moment(demandStartTime).subtract(this.moment().utcOffset(), 'minutes');
    return {
      id: id,
      start_y: target.year(),
      start_m: target.month() + 1,
      start_d: target.date(),
      start_hour: target.hour(),
      start_min: target.minute(),
      end_y: target.year(),
      end_m: target.month() + 1,
      end_d: target.date(),
      end_hour: target.hour(),
      end_min: target.minute()
    };
  }

  effectiveThreshold(targetPower, limitPower, contractPower) {
    if (targetPower > 0) {
      return targetPower;
    }
    if (limitPower > 0) {
      return limitPower;
    }
    if (contractPower > 0) {
      return contractPower;
    }
  }

  toggleFullScreen() {
    this.rootScope.isFullScreen = !this.rootScope.isFullScreen;
    // ng-if による DOM 変更が完了した後にグラフのサイズを変更する
    setTimeout(() => {
      if (this.rootScope.isFullScreen) {
        this.chart.setSize(null, 450, false);
      } else {
        this.chart.setSize(null, 400, false);
      }
      this.chart.redraw();
      this.chart.reflow();
    }, 350);
  }

  toggleSimpleDisplay() {
    this.rootScope.isSimpleDisplay = !this.rootScope.isSimpleDisplay;
    this.rootScope.isFullScreen = !this.rootScope.isFullScreen;
    this.update();
  }

  toggleTabletDisplay() {
    this.rootScope.isTabletDisplay = !this.rootScope.isTabletDisplay;
    this.rootScope.isFullScreen = !this.rootScope.isFullScreen;
    // 先にtimerを停止
    if (this.timer) {
      this.interval.cancel(this.timer);
    }
    if (this.rootScope.isTabletDisplay) {
      // 状態をcookieに保存 (ほぼ無期限＝30年)
      this.cookies.put('tabret_view', 'on', {expires: this.moment().add(30, 'year').toDate()});
      // 通信量削減のため、更新間隔を60秒に
      this.timer = this.interval(() => {
        this.update();
      }, 60000);
    } else {
      // cookieに無効を設定
      this.cookies.put('tabret_view', 'off', {expires: this.moment().add(30, 'year').toDate()});
      // タイマーを20秒へ戻す
      this.timer = this.interval(() => {
        this.update();
      }, 20000);
    }
    this.update();
  }
}

export default angular.module('leptonApp.demandDetail', [uiRouter, ngCookies, InstActivePowerService, SaConfigService, MonthlyMaxDemandPowerService, Chart, DateUtil, moment, MathUtil, CsvUtil, EventService, DeviceErrorService, PredictedPowerService, ActivePowerService, WeatherService])
  .config(routing)
  .component('demandDetail', {
    template: require('./demand_detail.html'),
    controller: DemandDetailController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand/detail/demand_detail.component.js